import React from "react";
import EventManager, {events} from "../../../utils/EventManager";
import {request} from "../../../api-client";
import PlaylistImage from "../../../assets/img/Letflow/playlist.jpg";
import SavedQueryImage from "../../../assets/img/Letflow/savedQuery.jpg";
import FavoritesImage from "../../../assets/img/Letflow/favorite.jpg";
import RecentsImage from "../../../assets/img/Letflow/recents.jpg";
import ProjectsImage from "../../../assets/img/Letflow/projects.jpg";
import NoImage from "../../../assets/img/Letflow/no-image.jpg";
import {Tooltip} from "@material-ui/core";
import HomeElementItemState from "./HomeElementItemStateX4";
import {Link} from "react-router-dom";
import { GAevent, generateLink } from "../../../api-client/core/authentication/utils";
import localization from "../../../config/localization";
import ShareDialog from "../../../components/Letflow/ShareDialog";
import styleRectangle from "./Styles/Carousel/documentary.module.css"
import styleSquare from "./Styles/Carousel/squareDescription.module.css"
import font from "./Styles/Fonts/fonts.module.css"
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import {ReactComponent as List} from "../../../components/Letflow/SvgIcons/list.svg"
import {ReactComponent as Heart} from "../../../components/Letflow/SvgIcons/heart.svg"
import {ReactComponent as Share} from "../../../components/Letflow/SvgIcons/share.svg"
import {ReactComponent as Person} from "../../../components/Letflow/SvgIcons/person.svg"
import {ReactComponent as Group} from "../../../components/Letflow/SvgIcons/groups.svg";
import {convertFromRaw, EditorState} from "draft-js";
import RichEditor from "../../../components/Letflow/RichTextEditor/EditorialEditor";
import AddToPlaylist from "../../../components/Letflow/AddToPlaylist";


export const makeImageCarousel = (element, imgSize = {width: 400, height: 400, fit: false}) => {
  let image;
  if (element.kind === "playlist") {
    if (element.image) {
      image = request.file.image.makeCroppedUrl(element.image.id, 400, 400);
    } else if (element.featuredImage && element.featuredImage.image) {
      image = request.file.image.makeCroppedUrl(
        element.featuredImage.image.id,
        400,
        400
      );
    } else {
      image = PlaylistImage;
    }
  } else if (element.kind === "savedQuery") {
    if (element.featuredImage && element.featuredImage.image) {
      image = request.file.image.makeCroppedUrl(
        element.featuredImage.image.id,
        400,
        400
      );
    } else {
      image = SavedQueryImage;
    }
  } else if (element.kind === "favorites") {
    if (element.image) {
      image = request.file.image.makeCroppedUrl(element.image.id, 400, 400);
    } else {
      image = FavoritesImage;
    }
  } else if (element.kind === "recents") {
    if (element.image) {
      image = request.file.image.makeCroppedUrl(element.image.id, 400, 400);
    } else {
      image = RecentsImage;
    }
  } else if (element.kind === "production") {
    if (element.featuredImage && element.featuredImage.image) {
      image = request.file.image.makeCroppedUrl(
        element.featuredImage.image.id,
        400,
        400
      );
    } else {
      image = ProjectsImage;
    }
  }
  else if (element.image) {
    image = request.file.image[imgSize.fit ? 'makeFittedUrl' : 'makeCroppedUrl'](element.image.id, imgSize.width, imgSize.height)
  } else {
    image = NoImage;
  }
  return image;
};

class HomeElementCarouselItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homeElement: this.props.homeElement,
      showShareDialog: false,
      showModal: false,
      limitReached: false,
    };
  }

  componentDidMount = () => {
    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_ITEM_DESCRIPTION, this.addToFavoriteItemDescription)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_ITEM_DESCRIPTION, this.removeFromFavoritesItemDescription)
    this.checkViewsLimit()
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_ITEM_DESCRIPTION, this.addToFavoriteItemDescription)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_ITEM_DESCRIPTION, this.removeFromFavoritesItemDescription)
  }

  checkViewsLimit = () => {
    if (this.props.data.view_limit > 0 && this.props.data.views >= this.props.data.view_limit) {
      this.setState({limitReached: true})
    }
  }

  addToFavoriteItemDescription = ({id, type}) => {
    this.addToFavorites({id, type})
  }

  removeFromFavoritesItemDescription = ({id, type}) => {
    this.removeFromFavorites({id, type})
  }

  addToFavorites = ({ id, type }) => {
    if (this.props.data.id === id && this.props.data.kind === type) {
      let items = this.state.homeElement.items.data.map(item => {
        if (item.id === id) {
          item.favorite = true;
        }
        return item;
      });
      this.setState({
        favorite: true,
        homeElement: { ...this.state.homeElement, items: { data: items } }
      });

      EventManager.getInstance().dispatch(events.ADD_TO_FAVORITE_BUTTON_PRESS, {id, type});
    }
  };

  removeFromFavorites = ({ id, type }) => {
    if (this.props.data.id === id && this.props.data.kind === type) {
      let items = this.state.homeElement.items.data.map(item => {
        if (item.id === id) {
          item.favorite = false;
        }
        return item;
      });

      this.setState({
        favorite: false,
        homeElement: { ...this.state.homeElement, items: { data: items } }
      });

      EventManager.getInstance().dispatch(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, {id, type});
    }
  };

  renderShareDialog = () =>
    <ShareDialog
      show={this.state.showShareDialog}
      handleClose={() => this.setState({showShareDialog: false})}
      entity={'playlist'}
      id={this.state.playlistToShareId}
    />

  toggleModalFavorite = (data) => {
    let items = this.state.homeElement.items.data.map(item => {
      if (item.id === data.id) {
        item.favorite = !item.favorite;
      }
      return item;
    });

    this.setState({
      homeElement: { ...this.state.homeElement, items: { data: items } }
    });
  }

  openContentCreatorModal = () => {
    EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: this.props.data.kind === 'video_content_creation' ? this.props.data.content_creator_id : this.props.data.id, dataType: "contentCreator", dataName: this.props.data.kind === 'video_content_creation' ? '' : this.props.data.name});
  }

  onContentCreatorClick = (e) => {
    e.preventDefault()
    e.stopPropagation();
    if (this.state.limitReached) {
      EventManager.getInstance().dispatch(events.OPEN_VIEWS_LIMIT_MODAL);
    } else {
      this.openContentCreatorModal()
    }
  }

  makeFavoriteButton = (data, favorite, icon) => {
    if (!this.state.limitReached) {
      let onClick = ''
      GAevent('Contenido', "Favorite", data.name || data.title)
      if (favorite) {
        onClick = (e) => {
          e.preventDefault();
          e.stopPropagation()
          this.removeFromFavorites({id: data.id, type: this.props.data.kind})
        }
      } else {
        onClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.addToFavorites({id: data.id, type: this.props.data.kind})
        }
      }

      switch (icon) {
        case 'star':
          return <Star onClick={onClick}/>
        case 'heart':
          return <Heart onClick={onClick}/>
        case 'list':
          return <List onClick={onClick}/>
      }
    }
  }

  makeEditorialDescription = (data) => {
    let description = EditorState.createWithContent(convertFromRaw(JSON.parse(data.shortDescription)))
    return description.getCurrentContent().getPlainText()
  }

  render = () => {
    const { data, handleElementClick } = this.props;

    let type;

    if (data.kind === "playlist") {
      type = "playlist";
    } else if (data.kind === "favorites") {
      type = "favorites";
    } else if (data.kind === "recents") {
      type = "recents";
    } else if (data.kind === "savedQuery") {
      type = "savedQuery";
    } else if (data.kind === "production") {
      type = "production";
    } else {
      type = "other";
    }

    const style = this.props.shape === 'rectangle' ? styleRectangle : styleSquare
    const imgSize = this.props.shape === 'rectangle' ? {width: 400, height: 500, fit: false} : {width: 400, height: 400, fit: false}

    return (
      <>
        <div className={style['items-content']}>
          {this.state.limitReached &&
          <Tooltip placement={"top"} title={localization.get('content.views_limit_reached')}>
            <Group className={style['limit-reached']}/>
          </Tooltip>
          }
          <Link
            to={generateLink(data.kind, data.id, data.title || data.name, false)}
            className={style['box']} style={{ backgroundColor: "#F4F4F4" }}
            onClick={(e) => {
              if (!['production', 'content_creator', 'playlist'].includes(data.kind)) {
                e.preventDefault()
                e.stopPropagation();
                handleElementClick()
              } else if (data.kind === 'content_creator') {
                this.onContentCreatorClick(e)
              }
            }}
          >
            <Link
              className={style['photo-container']}
              rel="canonical"
              to={generateLink(data.kind, data.id, data.title || data.name, false)}
              onClick={(e) => {
                if (!['production', 'content_creator', 'playlist'].includes(data.kind)) {

                  e.preventDefault()
                  e.stopPropagation();
                  handleElementClick()
                } else if (data.kind === 'content_creator') {
                  this.onContentCreatorClick(e)
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <div
                className={style['photo']}
                style={{
                  backgroundImage: `url(${makeImageCarousel(data, imgSize)})`,
                }}
              >
                {((type === "playlist" && (!data.created_by_admin || !data.image)) || type === "savedQuery" || type === "production") && (
                  <div
                    className="featured-image-title"
                    style={{
                      color: data.featuredImage
                        ? data.featuredImage.color
                        : "rgb(252, 205, 47)"
                    }}
                  >
                    {data.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "")|| data.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}
                  </div>
                )}
              </div>
              <HomeElementItemState
                recentlyCreated={data.recentlyCreated}
                recentlyUpdated={data.recentlyUpdated}
                fullOpacity={this.state.over}
              />
            </Link>

            <div className={style['info']}>
              <div className={`${style["title"]}`}>
                {data.title || data.name}
              </div>
              <div className={`${style["text"]}`}>
                <p>{(data&& data.type && data.type.type == 'talent') ? data.type.name : (data.subtitle || <span>&nbsp;</span>)}</p>
                {data.shortDescription ?
                    (data.type && data.type.type === 'editorial') ? this.makeEditorialDescription(data) :
                      data.shortDescription.replace(/<[^>]*>|&nbsp;/g, ' ')
                  :
                    <span>&nbsp;</span>
                }
              </div>
            </div>

              {['content_creator', 'playlist', 'video_content_creation'].includes(this.props.data.kind) &&
              <div className={style["icons"]}>
                {data.kind === "playlist" &&
                  <Tooltip placement="bottom" title={localization.get("share")}>
                    <div className={style['list']}>
                      <Share onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation();
                        this.setState({showShareDialog: true, playlistToShareId: data.id})
                      }}/>
                    </div>
                  </Tooltip>
                }
                {data.kind === "video_content_creation" &&
                  <Tooltip placement="bottom" title={localization.get("go_to_content_creator")}>
                    <div className={style['list']}>
                      <Person onClick={(e) => {
                        e.stopPropagation();
                        e.stopPropagation();
                        this.openContentCreatorModal()
                      }}/>
                    </div>
                  </Tooltip>
                }
                {(data.kind === "content_creator" || data.kind === "video_content_creation") &&
                    <div className={style['list']}>
                      <AddToPlaylist
                        id={data.id}
                        content={data.kind === "content_creator" ? "contentCreators" : "contentCreations"}
                        onClick={(e) => e}
                        icon={
                          <Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                            <List/>
                          </Tooltip>
                        }
                      />
                    </div>
                }
                <Tooltip placement="bottom" title={localization.get(this.state.favorite ? "soundbar.remove_from_favorites" : "soundbar.add_to_favorites")}>
                  <div className={`${style['star']} ${this.state.favorite && style['active']}`}>
                    {this.makeFavoriteButton(data, this.state.favorite, 'star')}
                  </div>
                </Tooltip>
              </div>
            }
          </Link>
        </div>
      {this.renderShareDialog()}
      </>
    );
  };
}

export default HomeElementCarouselItem;

